import axios from 'axios'

// const host = 'http://gnjf.drefore.cn'
const host = 'http://localhosts:8080'
const projectPath = '/heatingcharge'
const routerBase = projectPath + '/mobile'

axios.defaults.baseURL = host + projectPath


export default {
  host,
  routerBase,
  baseUrl: host + routerBase,
  getQueryString (name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
    let r = window.location.search.substr(1).match(reg)
    if (r != null) {
      console.log(decodeURIComponent(r[2]))
      return decodeURIComponent(r[2])
    }
    return null
  },
  request (url, params) {
    return new Promise((resolve, reject) => {
      axios.post(url, params)
        .then(response => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getUser () {
    let params = {
      code: this.getQueryString('code'),
      type: this.getQueryString('type')
    }
    return this.request('/wechat/in', params)
  },
  getJSSDKConfig (params) {
    return this.request('/wechat/jssdk', params)
  },
  getInfo (params) {
    return this.request('/wechat/getInfo', params)
  },
  getHeatingData (params) {
    return this.request('/wechat/payment/getHeatingData', params)
  },
  getPayment (params) {
    return this.request('/wechat/payment/getPayment', params)
  },
  register (params) {
    return this.request("/wechat/user/register", params)
  },
  getCode (params) {
    return this.request("/wechat/user/getCode", params)
  },
  getHousingList (params) {
    return this.request("/wechat/Housing/getHousingList", params)
  },
  getClientDetails (params) {
    return this.request("/wechat/Housing/getClientDetails", params)
  },
  addHousing (params) {
    return this.request("/wechat/Housing/addHousing", params)
  },
  delHousing (params) {
    return this.request("/wechat/Housing/delHousing", params)
  },
  getMyHeating (params) {
    return this.request("/wechat/payment/getHeatingData2", params)
  },
  prepay (params) {
    return this.request("/wechat/prepay", params)
  },
  pay (params) {
    return this.request("/wechat/pay", params)
  },
  generatePayment (params) {
    return this.request("/wechat/payment/generatePayment", params)
  },
  sendTemplate (params) {
    return this.request("/wechat/payment/sendTemplate", params)
  },
  checkTotalFee (params) {
    return this.request("/wechat/payment/checkTotalFee", params)
  }
}




// WEBPACK FOOTER //
// ./src/api/api.js